var map = {
	"./King-in-the-north.jpg": 37,
	"./Looks-like-you-choked.jpg": 38,
	"./Pathetic.jpg": 39,
	"./Pretty-badass.jpg": 40,
	"./Shame.jpg": 41,
	"./We-hoped-for-more.jpg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;